// End screen. Shown once when the sim reports game over.
import type { World } from '../sim';

export function showGameOver(parent: HTMLElement, world: World, restart: () => void): void {
  const el = document.createElement('div');
  el.className = 'gameover';
  el.innerHTML = `
    <div class="gameover-card">
      <h1>The grid failed</h1>
      <p>Day ${world.time.day}. Too many homes went dark.</p>
      <div class="gameover-stats">
        <div><strong>${Math.floor(world.score.homeDays)}</strong><span>home-days served</span></div>
        <div><strong>${world.score.peakHomes}</strong><span>peak homes lit</span></div>
        <div><strong>${world.score.daysSurvived}</strong><span>days survived</span></div>
      </div>
      <button class="btn btn-primary">Play again</button>
    </div>`;
  parent.appendChild(el);
  requestAnimationFrame(() => el.classList.add('show'));
  el.querySelector('button')?.addEventListener('click', restart);
}
